
document.querySelectorAll('.collection-tabs-wrapper .filter-products').forEach(function(CollectionTabs){
  CollectionTabs.addEventListener('click', function() { 
     document.querySelectorAll('.product-first-img').forEach(function(productImages){
   let images =   productImages.getAttribute('tab-data-images')
         productImages.setAttribute('src',images)
     })
  })
})
document.addEventListener('DOMContentLoaded', function () {
  const tabs = document.querySelectorAll('.js-ajax-tab');
  const targetContainer = document.querySelector('.yv-tab-content');

  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      const collectionHandle = this.getAttribute('collection-handle');
     // targetContainer.innerHTML = `<div class='tab-loader-image'><img src='https://cdn.shopify.com/s/files/1/0614/1817/6621/files/1484.gif?v=1753264767'></div>`;
      if (!collectionHandle) return;
      const url = `https://www.creslia.com/collections/${collectionHandle}?section_id=tab-ajax-data`;
      fetch(url)
        .then(response => response.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');         
          const tabPane = doc.querySelector('.yv-tab-pane');
          if (tabPane) {
            targetContainer.innerHTML = tabPane.outerHTML;          
            
              const sliders = targetContainer.querySelectorAll('[data-flickity-slider]');
              sliders.forEach(function (sliderEl) {
                const options = sliderEl.getAttribute('data-flickity-slider');
                try {
                  const parsedOptions = options ? JSON.parse(options) : {};
                  new Flickity(sliderEl, parsedOptions);
                } catch (e) {
                  console.error('Invalid Flickity options:', e);
                }
              }); 
              
              document.querySelectorAll('.yv-tab-content .animated-grid').forEach(function (animated) {
              animated.classList.add('aos-init', 'aos-animate');
            });           
          } else {
            targetContainer.innerHTML = '<p>No content found.</p>';
          }
        })
        .catch(error => {
          console.error('AJAX load error:', error);
          targetContainer.innerHTML = '<p>Error loading tab content.</p>';
        });
    });
  });
});



